import { useState } from 'react'

const usePagination = () => {
  const [ page, setPage]  = useState<number>(1)
  const [ limit, setLimit ] = useState<number>(10)
  const [ total, setTotal ] = useState<number>(0)
  const [ search, setSearch ] = useState<string>('')
  return { page, limit, search, setSearch, total, setTotal, setPage, setLimit }
}
export default usePagination;
